const indexItems = [
  { title: '悬疑烧脑专区', count: '386部', desc: '高智商对决，反转不断，让你欲罢不能的悬疑佳作。', icon: 'ri-search-eye-line' },
  { title: '温情治愈剧场', count: '214部', desc: '治愈系影视温暖你的心，在光影中感受生活美好。', icon: 'ri-heart-line' },
  { title: '热血动作大片', count: '529部', desc: '荷尔蒙爆棚的动作盛宴，每一帧都是肾上腺素。', icon: 'ri-fire-line' },
  { title: '喜剧爆笑合集', count: '347部', desc: '解压利器，笑到停不下来，赶走所有不开心。', icon: 'ri-emotion-laugh-line' },
  { title: '纪录片精选', count: '183部', desc: '探索世界真相，拓展认知边界，每一部都是知识盛宴。', icon: 'ri-earth-line' },
  { title: '爱情经典回顾', count: '268部', desc: '跨越时空的浪漫，或甜蜜或遗憾，总有一部戳中你。', icon: 'ri-heart-2-line' },
  { title: '恐怖惊悚专场', count: '195部', desc: '胆子够大你就来，深夜独自观影的极限挑战。', icon: 'ri-ghost-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">主题索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">按主题快速探索片库，每个专区都有精选高分作品等你发现。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.slice(0, 6).map((item, i) => (
            <div
              key={i}
              className="group flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-lg text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm md:text-base font-bold font-heading text-foreground-950">{item.title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          <div className="sm:col-span-2 lg:col-span-3">
            <div
              className="group flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${indexItems[6].icon} text-lg text-accent-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm md:text-base font-bold font-heading text-foreground-950">{indexItems[6].title}</h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{indexItems[6].count}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{indexItems[6].desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}